import React, { useEffect, useState } from "react";
import { ShieldCheck, Building2, Leaf, Tag } from "lucide-react";
import axios from "axios";
import { Link } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const Partners = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/partners`);
        setPartners(response.data);
        console.log(response.data);
      } catch (err) {
        setError("Failed to fetch partners.");
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  return (
    <div className="">
      <div className=" py-6 px-8 rounded-b-[100px] min-h-[150px]">
        <div className="max-w-3xl mx-auto text-center font-bold text-xl md:text-3xl">
          <h2 className="font-bold text-xl md:text-3xl text-blue-800">
            <span className="font-semibold text-gray-800">
              We partner with{" "}
            </span>
            industry-leading manufacturers{" "}
            <span className="font-semibold text-gray-800">
              from Poland, Taiwan, Korea, Turkey and many more to
            </span>
          </h2>
        </div>
        <div className="text-center font-bold text-4xl md:text-5xl mt-2 text-blue-800">
          Deliver
        </div>

        {/* <div className="text-center mt-8 text-xl font-semibold text-gray-800">
          Delivering Excellence Through Partnership
        </div> */}

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 place-items-center">
          <div className="p-5 flex flex-col items-start">
            <ShieldCheck size={50} className="text-blue-600 mb-4" />
            <h3 className="text-xl font-bold text-gray-900">
              Premium Gas Equipments
            </h3>
            <p className="text-gray-700 mt-2">
              Industry-leading gas equipments manufacturers, ensuring
              reliability and safety.
            </p>
          </div>

          <div className="p-5 flex flex-col items-start">
            <Leaf size={50} className="text-green-600 mb-4" />
            <h3 className="text-xl font-bold text-gray-900">
              Sustainable Materials
            </h3>
            <p className="text-gray-700 mt-2">
              Committed to eco-friendly and energy-efficient gas technologies
              for a greener future.
            </p>
          </div>

          <div className="p-5 flex flex-col items-start">
            <Building2 size={50} className="text-blue-600 mb-4" />
            <h3 className="text-xl font-bold text-gray-900">
              Wide Range of Gas Equipments
            </h3>
            <p className="text-gray-700 mt-2">
              Wide Range of customizable gas equipements for various industries
              and household needs.
            </p>
          </div>
        </div>
      </div>
      <h2 className="my-3 text-4xl font-extrabold text-gray-900 text-center">
        Our Partners
      </h2>
      {loading && <p className="pl-3">Loading partners...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {!loading && !error && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6 place-items-center">
          {partners.map((partner) => (
            <Link
              key={partner._id}
              to={`/partner/${partner._id}`} // ✅ Navigate to Partner Details Page
              state={{ partner }} // ✅ Pass Partner Data as State
              className="transform transition duration-300 hover:scale-[1.02] h-full"
            >
              <div
                key={partner._id}
                className="h-full bg-white shadow-md hover:cursor-pointer hover:shadow-xl transition-shadow rounded-xl py-3 px-2 text-center border border-gray-300 flex flex-col items-center w-96"
              >
                {/* Partner Logo */}
                <div className="w-full h-40 bg-gray-100 rounded-lg flex justify-center items-center overflow-hidden shadow-sm">
                  <img
                    src={partner.photos?.[0]?.data || "/placeholder.png"}
                    alt={partner.companyName}
                    className="w-3/4 h-full object-contain"
                  />
                </div>

                {/* Partner Name */}
                <h3 className="text-lg font-semibold text-gray-900 mt-4 hover:text-blue-600 transition">
                  {partner.companyName}
                </h3>

                {/* Partner Country */}
                <span className="text-sm font-medium text-gray-700 mt-1">
                  {partner.country}
                </span>

                {/* Visible <hr> Separator */}
                <hr className="w-full border-t border-gray-300 my-3" />

                <div className="w-full flex items-start mb-2">
                  {/* Label Section (20%) */}
                  <div className="w-1/12 mx-2 min-w-[50px] flex items-center text-sm text-gray-600">
                    <Tag className="w-4 h-4 mr-1" />
                    <span>Tags:</span>
                  </div>

                  <div className="w-11/12">
                    {partner.tags.length > 0 && (
                      <div className="flex flex-wrap gap-2">
                        {partner.tags.map((tag, index) => (
                          <span
                            key={index}
                            className="inline-flex items-center text-sm font-medium text-gray-700 border border-gray-400 px-2 py-1 rounded-md"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="mt-auto text-blue-600 cursor-pointer hover:underline">
                  Learn More
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Partners;
